import { ICardService } from "./ICardService";
import { BaseService } from "../base/BaseService";
import { ICardRepository } from "./ICardRepository";
import { ICard } from "./ICard";

export class CardService extends BaseService implements ICardService {

    cardRepository: ICardRepository;
    constructor() {
        super();
        this.cardRepository = this.dependencies.cardRepository;
    }

    getId(item: ICard): string {
        return this.cardRepository.getId(item);
    }
    getAll(): Promise<ICard[]> {
        return this.cardRepository.getAll();
    }
    getById(id: string): Promise<ICard | undefined> {
        return this.cardRepository.getById(id);
    }
    save(item: ICard): Promise<any> {
        return this.cardRepository.save(item);
    }
    saveAll(items: ICard[]): Promise<any> {
        return this.cardRepository.saveAll(items);
    }
    delete(id: string): Promise<any> {
        return this.cardRepository.delete(id);
    }
}
